<div>
  <a class="link" [class]="checkcurrentfont('ubuntu')"   (click)="togglefont('ubuntu')"  >Ubuntu</a>
  &nbsp;|&nbsp;
  <a class="link" [class]="checkcurrentfont('lato')"     (click)="togglefont('lato')"    >Lato</a>
  &nbsp;|&nbsp;
  <a class="link" [class]="checkcurrentfont('opensans')" (click)="togglefont('opensans')">OpenSans</a>
</div>
